import React from "react";


function Navbars() {



    return (
        <div className="">
            <div className="paytm-loader mt10">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )

}
export default Navbars;